export default "__VITE_ASSET__DjbV7Z5B__"